var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var eventQueue = [];
var waitForGTMLoaded = function () { return __awaiter(void 0, void 0, void 0, function () {
    var checkPromise, timeoutPromise;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (typeof window === 'undefined') {
                    return [2 /*return*/, false];
                }
                if (window._isGtmLoaded === true) {
                    return [2 /*return*/, true];
                }
                checkPromise = new Promise(function (resolve) {
                    if (window.dataLayer.some(function (item) { return item.event === 'gtm.load'; })) {
                        window._isGtmLoaded = true;
                        while (eventQueue.length) {
                            var event_1 = eventQueue.shift();
                            if (event_1)
                                pushToDataLayer(event_1.event, event_1.data);
                        }
                        resolve(true);
                        return;
                    }
                    var intervalId = setInterval(function () {
                        if (window.dataLayer.some(function (item) { return item.event === 'gtm.load'; })) {
                            clearInterval(intervalId);
                            window._isGtmLoaded = true;
                            while (eventQueue.length) {
                                var event_2 = eventQueue.shift();
                                if (event_2)
                                    pushToDataLayer(event_2.event, event_2.data);
                            }
                            resolve(true);
                        }
                    }, 500);
                    window.addEventListener('beforeunload', function () { return clearInterval(intervalId); }, { once: true });
                });
                timeoutPromise = new Promise(function (resolve) {
                    setTimeout(function () {
                        resolve(false);
                    }, 30000);
                });
                return [4 /*yield*/, Promise.race([checkPromise, timeoutPromise])];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var initializeGtm = function (gtmId) { return __awaiter(void 0, void 0, void 0, function () {
    var TagManager;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (typeof window === 'undefined')
                    return [2 /*return*/];
                if (!gtmId || (window === null || window === void 0 ? void 0 : window._isGtmLoaded))
                    return [2 /*return*/];
                return [4 /*yield*/, import('react-gtm-module')];
            case 1:
                TagManager = (_a.sent()).default;
                setTimeout(function () {
                    TagManager.initialize({ gtmId: gtmId });
                    waitForGTMLoaded();
                }, 3000);
                return [2 /*return*/];
        }
    });
}); };
var pushToDataLayer = function (event, data) {
    if (typeof window === 'undefined')
        return;
    if (!window._isGtmLoaded) {
        eventQueue.push({ event: event, data: data });
        return;
    }
    if (!window.dataLayer) {
        window.dataLayer = window.dataLayer || [];
    }
    window.dataLayer.push(__assign({ event: event }, data));
};
var pushUserToDataLayer = function (event, me, profile) {
    var _a, _b;
    var user = {};
    if (me) {
        user.userId = me.id;
        user.userName = me.name;
    }
    if (profile) {
        user.profileId = profile.id;
        user.profileName = profile.name;
        user.profilePhone = (_a = profile.phone) === null || _a === void 0 ? void 0 : _a.phone;
        user.profileEmail = (_b = profile.email) === null || _b === void 0 ? void 0 : _b.email;
    }
    pushToDataLayer(event, user);
};
export { initializeGtm, pushToDataLayer, pushUserToDataLayer };
//# sourceMappingURL=gtm.js.map